import React from 'react';
import './MapSection.css';

const MapSection = ({ config }) => {
  return (
    <div className="map-section">
      <div className="map-content">
        <div className="map-image">
          <img 
            src={config.mainImage} 
            alt="Nexus Asili Location Map" 
            className="map-img"
          />
        </div>
        
        <div className="map-overlay">
          <div className="overlay-content">
            <p className="overlay-text">
              {config.overlayText}
            </p>
            <button 
              className="location-btn"
              onClick={() => window.open('https://maps.app.goo.gl/RWaqqhxL5i1njKqJ7?g_st=iw', '_blank')}
            >
              <img 
                src="/images/icons/map-icon.svg" 
                alt="Map Icon" 
                className="map-icon"
              />
              <span>{config.locationButtonText}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapSection;
